import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from '@heroui/react';
import * as m from '@paraglide/messages';
/**
 * 재사용 가능한 확인 모달 컴포넌트
 *
 * @example
 * ```tsx
 * <ConfirmModal
 *   isOpen={isOpen}
 *   title="데이터 삭제"
 *   message="정말로 이 데이터를 삭제하시겠습니까?"
 *   confirmText="삭제"
 *   isDangerous
 *   onConfirm={handleDelete}
 *   onCancel={() => setIsOpen(false)}
 * />
 * ```
 */ export var ConfirmModal = function(param) {
    var isOpen = param.isOpen, title = param.title, message = param.message, confirmText = param.confirmText, cancelText = param.cancelText, confirmColor = param.confirmColor, _param_cancelColor = param.cancelColor, cancelColor = _param_cancelColor === void 0 ? 'default' : _param_cancelColor, onConfirm = param.onConfirm, onCancel = param.onCancel, _param_size = param.size, size = _param_size === void 0 ? 'sm' : _param_size, _param_showCloseButton = param.showCloseButton, showCloseButton = _param_showCloseButton === void 0 ? false : _param_showCloseButton, _param_isDismissable = param.isDismissable, isDismissable = _param_isDismissable === void 0 ? false : _param_isDismissable, _param_isLoading = param.isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading, _param_isDangerous = param.isDangerous, isDangerous = _param_isDangerous === void 0 ? false : _param_isDangerous;
    // Paraglide 메시지 함수 사용
    var finalTitle = title || m.common_confirm();
    var finalConfirmText = confirmText || m.common_confirm();
    var finalCancelText = cancelText || m.common_cancel();
    var finalConfirmColor = confirmColor || (isDangerous ? 'danger' : 'primary');
    return /*#__PURE__*/ React.createElement(Modal, {
        isOpen: isOpen,
        size: size,
        isDismissable: isDismissable,
        hideCloseButton: !showCloseButton,
        placement: "center",
        onClose: onCancel
    }, /*#__PURE__*/ React.createElement(ModalContent, null, function() {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ModalHeader, {
            className: "flex flex-col gap-1"
        }, finalTitle), /*#__PURE__*/ React.createElement(ModalBody, null, typeof message === 'string' ? /*#__PURE__*/ React.createElement("p", null, message) : message), /*#__PURE__*/ React.createElement(ModalFooter, null, /*#__PURE__*/ React.createElement(Button, {
            color: cancelColor,
            variant: "light",
            onPress: onCancel,
            isDisabled: isLoading
        }, finalCancelText), /*#__PURE__*/ React.createElement(Button, {
            color: finalConfirmColor,
            onPress: onConfirm,
            isLoading: isLoading
        }, finalConfirmText)));
    }));
};
